import React from 'react';

const HomePage: React.FC = () => (
  <div className="content-container">
    <h1>Welcome to My Portfolio!</h1>
    <p>Hello and welcome! I’m Amyr Neto, a passionate software developer 
      with a strong background in building robust solutions and a deep curiosity 
      for technology. This site is designed to offer you a glimpse into my 
      professional journey, personal interests, and the work that excites me most.
      Here’s what you’ll find as you explore each tab:</p>
    <h2>About</h2>
    <p>Learn more about my professional background, core skills, 
      and what drives me as a developer. I share my approach to 
      problem-solving, teamwork, and continuous learning—a bit 
      of what shapes me both in and out of the workplace.</p>
    <h2>Projects</h2>
    <p>Discover some of the key projects I’ve worked on, from
      real-world business solutions to personal initiatives. 
      Here, you’ll find case studies, technical highlights, 
      and insights into how I tackle challenges and deliver results.</p>
    <h2>Guaipeca</h2>
    <p>Coding isn’t just my career—it’s also my hobby! In the Guaipeca tab, 
      I share my journey into game development, including experiments, prototypes, 
      and what I’ve learned bringing playful ideas to life. It’s a peek into my creative 
      side and love for interactive technology.</p>
    <h2>Contact</h2>
    <p>I’m always open to new connections, collaborations, or just a good tech chat. 
      If you’d like to get in touch—whether for professional opportunities or to 
      share ideas—head over to the Contact tab. I look forward to hearing from you!</p>
    <p>Thank you for visiting. Enjoy exploring my portfolio!</p>
  </div>
);

export default HomePage;